/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useMemo } from "react";

import Tooltip from "./Tooltip";

interface LongTextTooltipProps {
  children: any;
  title: any;
  open: boolean;
  customStyles?: any;
  customMaxWidth?: string;
}

export const LongTextTooltip = ({
  children,
  title,
  open,
  customStyles,
  customMaxWidth
}: LongTextTooltipProps) => {
  const tooltipStyles = useMemo(
    () =>
      css([
        {
          "& .MuiTooltip-tooltip": {
            maxWidth: customMaxWidth ?? "unset"
          }
        },
        customStyles
      ]),
    [customMaxWidth, customStyles]
  );

  return (
    <Tooltip
      size="medium"
      placement="top"
      title={title}
      disableHoverListener={!open}
      css={tooltipStyles}
    >
      {children}
    </Tooltip>
  );
};
